export class excelUtils {

    static downloadExcel(file: Blob, name: string){
        const link = document.createElement('a');
        const url = URL.createObjectURL(new Blob([file], { type: 'application/octet-stream' }));

        link.href = url;
        link.target = '_blank'
        link.download = name + '.xlsx';
        link.click();
    }
}